import { Route, NavigationGuardNext } from "vue-router";
import { getModule } from "vuex-module-decorators";
import LessonPlanListState from "@/modules/lesson-plan-list";
import LessonPlanTemplateState from "@/modules/lesson-plan-template";
import { AppBreadCrumbModule } from "@/modules/bread-crumb";
import { Paths } from "@/util/paths";
import { fmtMsg } from "commonui";
import { BreadCrumbMenuLocale } from "@/locales/localeid";

export const LessonPlanListResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	const lessonPlanListModule = getModule(LessonPlanListState);
	const lessonPlanTemplateModule = getModule(LessonPlanTemplateState);
	const actions: Promise<void>[] = [];
	const { versionGroupId, methodology, lessonPlanVersionId } = to.params;
	const { unitId } = to.query;
	actions.push(
		lessonPlanListModule.fetchLessonPlans({
			versionGroupId,
			methodology,
			lessonPlanVersionId,
			unitId: unitId ? parseInt(unitId as string, 10) : undefined
		})
	);
	actions.push(lessonPlanTemplateModule.fetchLessonPlanTemplates());
	await Promise.all(actions);

	const appBreadCrumbModule = AppBreadCrumbModule;
	const appRoutes = [
		{
			path: Paths.LessonPlanVersion,
			breadcrumbName: fmtMsg(BreadCrumbMenuLocale.BreadCrumbMenuLPV),
			params: {},
			queryParams: {}
		}
	];

	if (versionGroupId && methodology && lessonPlanVersionId && unitId) {
		appRoutes.push({
			path: Paths.LessonPlanListWithParams,
			breadcrumbName: fmtMsg(BreadCrumbMenuLocale.BreadCrumbMenuLPList),
			params: {
				versionGroupId,
				methodology,
				lessonPlanVersionId
			},
			queryParams: {
				unitId: unitId ? parseInt(unitId as string, 10) : undefined
			}
		});
	} else if (versionGroupId && methodology && lessonPlanVersionId) {
		appRoutes.push({
			path: Paths.LessonPlanListWithParams,
			breadcrumbName: fmtMsg(BreadCrumbMenuLocale.BreadCrumbMenuLPList),
			params: {
				versionGroupId,
				methodology,
				lessonPlanVersionId
			},
			queryParams: {}
		});
	} else {
		appRoutes.push({
			path: Paths.LessonPlanList,
			breadcrumbName: fmtMsg(BreadCrumbMenuLocale.BreadCrumbMenuLPList),
			params: {},
			queryParams: {}
		});
	}
	appBreadCrumbModule.setBreadCrumbRoutes(appRoutes);
	next();
};
